import ApiRequest from '../request'

export default class Pvags {
  constructor() {
    this.apiRequest = new ApiRequest({ useWindowLocation: true })
  }
  async getPvagsconvocation(id) {
    try {
      const res = await this.apiRequest.get(`pvagsconvocation/${id}`)
      return res
    } catch (error) {
      return error.response
    }
  }
}
